import * as yup from 'yup';
import { AnyObjectSchema } from 'yup';

import { ICompanySettings } from 'auth/types';
import { upsertCustomerQuoteSchema } from 'quotes/components/CustomerQuoteUpsert';
import { upsertVendorQuoteSchema } from 'quotes/components/VendorQuoteUpsert';
import { QuoteEntityType, QuoteType } from 'quotes/enums';

import { ItemsToCopyField } from './enums';

interface IProps {
  selectedQuoteId?: number;
  addToQuoteType: QuoteType;
  companySettings?: ICompanySettings;
  itemsToCopyValues: ItemsToCopyField[];
  isAlternateVersionEnabled?: boolean;
}

export const getSchema = ({
  selectedQuoteId,
  addToQuoteType,
  itemsToCopyValues,
  companySettings,
  isAlternateVersionEnabled,
}: IProps) => {
  const baseSchema = selectItemsToCopySchema(itemsToCopyValues);

  if (selectedQuoteId) {
    return baseSchema;
  }

  switch (addToQuoteType) {
    case QuoteType.VENDOR:
      return upsertVendorQuoteSchema(QuoteEntityType.QUOTE).concat(baseSchema);
    case QuoteType.CUSTOMER:
    default:
      return (
        upsertCustomerQuoteSchema({
          entityType: QuoteEntityType.QUOTE,
          companySettings,
          isEdit: false,
          isAlternateVersionEnabled,
        }) as AnyObjectSchema
      ).concat(baseSchema);
  }
};

export const selectItemsToCopySchema = (itemsToCopyValues: ItemsToCopyField[]) =>
  yup.object().shape({
    ...itemsToCopyValues.reduce((acc, value) => {
      acc[value] = yup.boolean().nullable();

      return acc;
    }, {}),
  });
